<template>
  <div id="app">
    <el-container v-if="isLoadingFunc">
      <navigation />
      <el-main>
        <header-strip></header-strip>
        <router-view></router-view>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import HeaderStrip from '../components/common/HeaderStrip.vue'
import NavigationVue from '../components/common/Navigation.vue';
export default {
  mounted() {
    //  to void ui glitchs or previous layout etc.
    let self = this
    let str = self.$route.path
    let cpath = self.$route.path
    let sindex = str.indexOf("/", 2)
    if(sindex > 0) {
      let currpath = str.substr(0, sindex);
      cpath = currpath
    }
    let menuItem = self.$router.options.routes
    let result = _.some(menuItem, (e) => {
      let estr = e.path
      let epath = e.path
      let eindex = estr.indexOf("/", 2)
      if(eindex > 0) {
        let curepath = estr.substr(0, eindex)
        epath = curepath
      }
      return epath === cpath
    })
    if (result) {
      self.isLoading = true;
    } else {
      self.isLoading = false
      self.$store.dispatch("auth/LOGOUT").then(() => {
        localStorage.setItem('userdetails',null)
        self.$router.push("/login");
      });
    }
  },
  components:{
    'header-strip':HeaderStrip,
    'navigation': NavigationVue
  },
  data () {
    return {
      isLoading:false,
      open: false
    }
  },
  computed:{
    isLoadingFunc:function(){
      let token = this.$store.getters['auth/getToken'];
      if(token) return this.isLoading;
    },
  }
}
</script>




// WEBPACK FOOTER //
// src/layouts/DesktopLayout.vue